import { useEffect } from "react";

/**
 * Injects (and updates/removes) a JSON-LD <script type="application/ld+json">
 * into <head> for the current route. Cleaned up on unmount so schema from one
 * page never leaks onto another in this single-page app.
 */
export function useJsonLd(id, data) {
  const serialized = JSON.stringify(data);
  useEffect(() => {
    let el = document.getElementById(id);
    if (!el) {
      el = document.createElement("script");
      el.type = "application/ld+json";
      el.id = id;
      document.head.appendChild(el);
    }
    el.textContent = serialized;
    return () => { el.remove(); };
  }, [id, serialized]);
}